<template>
  <div
    class="lg:px-20 md:px-12 px-5 lg:py-12 md:py-12 py-5 bge3ceff-opa"
    v-if="getAllEpisode.result.length"
  >
    <p
      class="fsize40 md-fsize28 sm-fsize20 font-semibold text-center clr-black lg:mb-12 md:mb-8 mb-6"
    >
      Recommended Podcasts
      <!-- {{
        Object.keys(user).length <= 0 || !getAllEpisode.result.length
          ? "Your  recent Podcasts"
          : ""
      }} -->
    </p>
    <div>
      <swiper :options="swiperOption" class="mySwiper">
        <template
          v-if="Object.keys(user).length <= 0 || !getAllEpisode.result.length"
        >
          <!-- <swiper-slide
            class="cursor-pointer"
            v-for="(item, index) in allEpisode"
            :key="index"
          >
            <div @click="createHistory(item._id)">
              <div
                class="relative w-full h-200 rounded-xl"
                @click="handleOpen(item.link)"
              >
                <img
                  class="w-full h-200 rounded-xl"
                  :src="handleFrame(item.link)"
                  alt="img"
                />
                <feather-icon
                  icon="PlayIcon"
                  class="clr-black icon-abs"
                  svgClasses="w-6 h-6"
                ></feather-icon>

                <iframe
                  class="w-full h-full rounded-xl border-0"
                  :src="handleFrame(item.link)"
                  frameborder="0"
                ></iframe>
                <div
                  class="absolute inset-0 w-full h-full bg-red cursor-pointer"
                ></div>
              </div>
              <p
                class="clr-black mt-4 sm-fsize14"
                @click="handleOpen(item.link)"
              >
                {{ item.title }}
              </p>
            </div>
          </swiper-slide> -->
        </template>
        <template>
          <swiper-slide
            class="cursor-pointer"
            v-for="(item, index) in getAllEpisode.result"
            :key="index"
          >
            <!--  -->
            <div @click="updateHistory(item._id)">
              <div
                class="relative w-full h-200 rounded-xl"
                @click="handleRedirect(item.podcastId._id)"
              >
                <!-- @click="handleOpen(item.link)" -->
                <img
                  class="w-full h-200 rounded-xl object-contain"
                  :src="`${$imageURL}/${item.image}`"
                  alt="img"
                />

                <div
                  class="absolute h-200 top-0 left-0 flex items-center justify-center w-full"
                >
                  <feather-icon
                    icon="PlayIcon"
                    class="text-darkPurple"
                    svgClasses="w-12 h-12 "
                  ></feather-icon>
                </div>
              </div>
              <p class="clr-black mt-4 text-center sm-fsize14">
                {{ item.title }}
              </p>
            </div>
          </swiper-slide>
          <div class="swiper-button-prev adminswiper" slot="button-prev"></div>
          <div class="swiper-button-next adminswiper" slot="button-next"></div>
        </template>
      </swiper>
    </div>
  </div>
</template>
<script>
import "swiper/dist/css/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapState } from "vuex";
export default {
  data() {
    return {
      swiperOption: {
        slidesPerView: 6,
        spaceBetween: 30,
        breakpoints: {
          1600: {
            slidesPerView: 6,
            spaceBetween: 30,
          },
          1300: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          900: {
            slidesPerView: 3.2,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 1.3,
            spaceBetween: 15,
          },
        },
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        observer: true,
        observeParents: true,
      },

      openAddBannerSidebar: false,
      allEpisode: {},
    };
  },
  components: {
    swiper,
    swiperSlide,
  },
  methods: {
    async dataLoad() {
      let payload = {
        limit: 7,
        sort: "-1",
        isRecommended: true,
        isDeleted: false,
      };
      if (Object.keys(this.user).length > 0) {
        // console.log("If", this.user);
        let { data } = await this.$store.dispatch("podcast/getall_history");
        this.allEpisode = data.result;
      }
      let { data } = await this.$store.dispatch(
        "podcast/getall_episode",
        payload
      );
      this.allEpisode = data.result;
    },
    handleRedirect(podcastId) {
      this.$router.push({
        name: "podcast-episodepage",
        query: { podcastId: podcastId },
      });
    },

    async createHistory(id) {
      if (Object.keys(this.user).length <= 0) return;
      let payload = {
        episodeId: id,
      };
      try {
        await this.$store.dispatch("podcast/add_history", payload);
        this.dataLoad();
      } catch (error) {
        console.log(error);
      }
    },
    async updateHistory(id) {
      if (Object.keys(this.user).length <= 0) return;
      let payload = {
        id: id,
      };
      try {
        await this.$store.dispatch("podcast/update_history", payload);
        await this.$store.dispatch("podcast/getall_history");
      } catch (error) {
        console.log(error);
      }
    },
    // handleFrame(url) {
    //   const regex =
    //     /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    //   const match = url.match(regex);
    //   return `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg`;
    // },

    // handleFrame(url) {
    //   const regex = /https?:\/\/open\.spotify\.com\/episode\/([a-zA-Z0-9]+)/;
    //   const match = url.match(regex);
    //   if (match) {
    //     return `https://i.scdn.co/image/${match[1]}/hqdefault.jpg`;
    //   }
    //   return "";
    // },
    handleOpen(url) {
      window.open(url, "_blank");
    },
  },
  computed: {
    ...mapState("podcast", {
      getAllHistory: "getAllHistory",
      getAllEpisode: "getAllEpisode",
    }),
    ...mapState("auth", { user: "user" }),
  },
  mounted() {
    this.dataLoad();
  },
};
</script>
